import {
  InstallmentSplitFormValues,
  InstallmentSplitRequest,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { Button, Form, Modal, ModalProps } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import SplitInstallmentForm from './SplitInstallmentForm';
import { useAccountPayableContext } from '@/pages/FinancialPages/BillToPayPage/ReleasesPage/ReleasesDetailsPage';
import { DateTimeFormat } from '@/utils/moment';
import { useInstallmentSplit } from '@/core/domain/financial/AccountPayable/AccountPayable.hooks';
import { handleInstallmentAlreadyEdited } from '@/core/domain/financial/AccountPayable/AccountPayable.errors';
import { AxiosError } from 'axios';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
}

const SplitInstallmentModal: React.FC<Props> = ({ onCancel, open }) => {
  const [form] = Form.useForm<InstallmentSplitFormValues>();

  const { currentInstallment, accountPayable } = useAccountPayableContext();
  const installment = accountPayable?.installmentPayables[currentInstallment];

  const splitInstallment = useInstallmentSplit();

  const handleSplitInstallment = async () => {
    const values = await form.validateFields();

    try {
      if (installment && values) {
        const obj: InstallmentSplitRequest = {
          ...values,
          accountPayableId: installment.accountPayableId,
          installmentPayableId: installment.id,
          fromThatDate: values.fromThatDate.format(DateTimeFormat),
          quantityInstallments: Number(values.quantityInstallments),
          currentSituation: installment.situation,
        };

        await splitInstallment.mutateAsync(obj);

        handleCancel();
      }
    } catch (err: unknown) {
      const error = err as AxiosError;

      if (error.response?.data) {
        if (handleInstallmentAlreadyEdited(error)) {
          handleCancel();
        }
      }
    }
  };

  useEffect(() => {
    if (installment) {
      form.setFieldsValue({
        ...installment,
        fromThatDate: moment(),
        valueTotal:
          installment.installmentValue + (installment.discountIncrease ?? 0),
        quantityInstallments: 1,
        intervalDays: 30,
      });
    }
  }, [installment, accountPayable, open]);

  function handleCancel() {
    onCancel();

    form.resetFields();
  }

  return (
    <Modal
      width={860}
      open={open}
      onCancel={handleCancel}
      title={'Parcelamento'}
      footer={[
        <Button type="primary" ghost onClick={onCancel}>
          Cancelar
        </Button>,
        <Button
          type="primary"
          loading={splitInstallment.isLoading}
          onClick={handleSplitInstallment}
        >
          Parcelar
        </Button>,
      ]}
      destroyOnClose
    >
      <SplitInstallmentForm form={form} />
    </Modal>
  );
};

export default SplitInstallmentModal;
